// Wrapped in rwInitProductOptions so the scent switcher (main-product.liquid) can
// re-run it after it swaps in a sibling scent's product section.
function rwInitProductOptions() {
let productOptions = document.querySelectorAll('.js-product-options');

productOptions = Array.from(productOptions);

productOptions.forEach((option) => {
    const handle = option.getAttribute('data-product-form');

    fetch('/products/' + handle + '.js')
    .then(function(response) {
      response.json().then(data => {
        let product = data;
        let variants = product.variants;

        function updateSelection() {
            console.log('updating selection');
            // Scope every buy-area lookup to .info__transaction. The minicart's
            // suggestion cards also carry .js-add-to-cart and come FIRST in the
            // DOM, so an unscoped querySelector stamps this product's variant id
            // onto an upsell card and leaves the real button stale.
            const buyArea = document.querySelector('.info__transaction');
            if (!buyArea) { return; }
            const addButton = buyArea.querySelector('.js-add-to-cart');
            const ctaLabel = buyArea.querySelector('.js-cta-label');
            const priceEl = buyArea.querySelector('.js-price');
            const qtyInput = buyArea.querySelector('.js-qty');

            let selfinder = [];

            productOptions.forEach(function (option) {
              var productOptionsInner = option.querySelectorAll('.js-product-option input:checked');

              if (productOptionsInner.length) {
                selfinder.push(productOptionsInner[0].value);
              }

            });

            let sel = [];

            variants.forEach((variant, i) => {
              // prefix match: selected option values in order (an empty
              // options container no longer breaks the lookup)
              if(selfinder.length && selfinder.every((v, idx) => variant.options[idx] === v)) {
                sel.push(variant);
              }
            });

            let selection = sel[0];
            if (!selection) { return; }

            let currentActive = document.querySelector('.option__image .image__wrapper.active');

            if (currentActive) {
              currentActive.classList.remove('active');
            }

            document.querySelector('.js-variant').textContent = selection.option1;

            // update desc
            let desc = metaData[selection.id].description;
            if(desc) {
              document.querySelector('.product__details .js-desc span').textContent = desc;
            }

            // update notes
            let notes = metaData[selection.id].notes;
            let notesList = document.querySelector('.js-notes ul');

            // update gallery: this variant's photos lead the thumbnails and the
            // first one takes the stage (product-gallery.js)
            let imageLit = metaData[selection.id].image_lit;
            let imageUnlit = metaData[selection.id].image_unlit;
            if (window.rwProductGallery && (imageLit || imageUnlit)) {
              window.rwProductGallery.setVariantImages(imageUnlit, imageLit, selection.name);
            }

            // console.log(metaData[selection.id].image_lit);
            if(metaData[selection.id].image_gallery) {
              console.log(metaData[selection.id].image_gallery);
            }

            if(notesList) {
              notesList.textContent = '';
            }

            if(notes && notesList) {
              notes.forEach((note) => {
                var li = document.createElement('li');
                li.innerText = note;
                notesList.appendChild(li);
              });
            }

            // update price
            let price = selection.price;
            if (priceEl) priceEl.innerHTML = '$' + (price/100);

            // update qty-input
            if (qtyInput) qtyInput.value = 1;

            // update inventory-qty
            let selector = option.querySelector('.js-product-option input');
            let inventoryQty = selector.dataset.inventoryQty;

            // update max
            if (qtyInput) {
              if (inventoryQty && inventoryQty > 0) {
                qtyInput.max = inventoryQty;
              } else if (inventoryQty == 0) {
                qtyInput.max = 1;
              } else {
                qtyInput.removeAttribute('max');
              }
            }

            // update cart button
            if (addButton) addButton.setAttribute('data-id', selection.id);


            // update availability
            let isAvailable = selection.available;

            if(isAvailable) {
              console.log('available');
              if (addButton) addButton.disabled = false;
              if (ctaLabel) ctaLabel.innerHTML = 'Add to bag -';
            } else {
              console.log('not available');
              if (addButton) addButton.disabled = true;
              if (ctaLabel) ctaLabel.innerHTML = 'Sold Out';
              if (priceEl) priceEl.innerHTML = '';
              if (qtyInput) { qtyInput.value = 0; qtyInput.max = 0; }
            }


            // update url
            if (selection) {
              var newUrl = window.location.href.split('?')[0] + '?variant=' + selection.id;
              history.pushState({}, null, newUrl);
              // window.location = newUrl
            }
        }

        // updateSelection();

        let productOption =  option.querySelector('.js-product-option');

        if (productOption) {
          productOption.addEventListener('change', (event) => {
            console.log('changed product option');
            updateSelection();
          });
        }
      });

    })
    .catch(function(error) {
      console.log(error);
    });
  });
}
window.rwInitProductOptions = rwInitProductOptions;
rwInitProductOptions();
